/**
 * Toast dispatch.
 *
 * A tiny publish/subscribe store, kept apart from the component that renders
 * it so any module — including a plain service — can raise a toast without
 * importing React.
 */

let sequence = 0;
const listeners = new Set();

export function toast(message, tone = 'info') {
  const entry = { id: (sequence += 1), message, tone };
  listeners.forEach((listener) => listener(entry));
  return entry.id;
}

toast.success = (message) => toast(message, 'success');
toast.error = (message) => toast(message, 'danger');

export function subscribeToToasts(listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export default toast;
